import { render, staticRenderFns } from "./DeactivateParent.vue?vue&type=template&id=befcb142"
import script from "./DeactivateParent.vue?vue&type=script&lang=js"
export * from "./DeactivateParent.vue?vue&type=script&lang=js"
import style0 from "./DeactivateParent.vue?vue&type=style&index=0&id=befcb142&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports